import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Sarah Chen",
      role: "Professional Trader",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=64&h=64&fit=crop&crop=face",
      content: `CryptoTrade Pro has transformed my trading experience. The advanced order types and real-time analytics give me the edge I need in volatile markets.
      
      The platform's reliability during high-volume periods is exceptional.`,
      rating: 5,
      tradingVolume: "$2.4M"
    },
    {
      id: 2,
      name: "Marcus Rodriguez",
      role: "Institutional Trader",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=64&h=64&fit=crop&crop=face",
      content: `The security features and institutional-grade tools make this platform perfect for high-volume trading. Customer support is responsive and knowledgeable.
      
      I've been using it for 2 years without any major issues.`,
      rating: 5,
      tradingVolume: "$8.7M"
    },
    {
      id: 3,
      name: "Emily Watson",
      role: "Crypto Enthusiast",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=64&h=64&fit=crop&crop=face",
      content: `As someone new to crypto trading, I appreciate the intuitive interface and educational resources. The mobile app keeps me connected to markets 24/7.
      
      Perfect balance of simplicity and advanced features.`,
      rating: 5,
      tradingVolume: "$156K"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <div className="bg-white bg-opacity-10 rounded-xl p-6 backdrop-blur-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-heading-semibold text-white">
          What Traders Say
        </h3>
        <div className="flex space-x-1">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 rounded-full transition-all duration-trading-fast ${
                index === currentIndex ? 'bg-white' : 'bg-white bg-opacity-40'
              }`}
            />
          ))}
        </div>
      </div>

      <div className="space-y-4">
        {/* User Info */}
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 rounded-full overflow-hidden bg-white bg-opacity-20">
            <img
              src={currentTestimonial.avatar}
              alt={currentTestimonial.name}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.src = "/assets/images/no_image.png";
              }}
            />
          </div>
          <div>
            <h4 className="font-body-medium text-white">
              {currentTestimonial.name}
            </h4>
            <p className="text-sm text-primary-100">
              {currentTestimonial.role}
            </p>
          </div>
        </div>

        {/* Rating */}
        <div className="flex items-center space-x-1">
          {[...Array(currentTestimonial.rating)].map((_, i) => (
            <Icon key={i} name="Star" size={16} className="text-yellow-400 fill-current" />
          ))}
        </div>

        {/* Testimonial Content */}
        <blockquote className="text-primary-50 text-sm leading-relaxed">
          <p>{currentTestimonial.content}</p>
        </blockquote>

        {/* Trading Stats */}
        <div className="flex items-center justify-between pt-3 border-t border-white border-opacity-20">
          <div className="flex items-center space-x-2">
            <Icon name="TrendingUp" size={16} className="text-primary-100" />
            <span className="text-xs text-primary-100">Trading Volume</span>
          </div>
          <span className="text-sm font-data text-white">
            {currentTestimonial.tradingVolume}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCarousel;